/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
//import { saveAs } from 'file-saver';
import { IconButton } from '@mui/material';
import { useGridApiRef, GridActionsCellItem } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import AskDialog from '../../../components/common/dialog/AskDialog';
import * as fileApi from '../../../lib/api/file';
import { listSalesFiles } from '../../../modules/projectModule/purchaseOrderFiles';
import SalesFileList from '../../../components/projectmng/purchaseorder/SalesFileList';

const SalesFileListContainer = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { project, files, error, loading } = useSelector(
    ({ projectModule, loading }) => ({
      project: projectModule.project.project,
      files: projectModule.purchaseOrderFiles.salesFiles,
      error: projectModule.purchaseOrderFiles.error,
      loading: loading['project/LIST_SALES_FILES'],
    }),
  );

  useEffect(() => {
    if (project) {
      dispatch(listSalesFiles({ prjUuid: project.prjUuid }));
    }
  }, [project]);

  const [visible, setVisible] = useState(false);

  const onCancle = () => {
    setVisible(false);
    setRemoveId(null);
  };

  const onConfirm = () => {
    setVisible(false);
    onRemove();
  };

  const [removeId, setRemoveId] = useState(null);
  const handleDeleteClick = (id) => (event) => {
    event.stopPropagation();

    //remove 작업
    setVisible(true);
    setRemoveId(id);
  };

  const onRemove = async () => {
    try {
      const res = await fileApi.removeFile(removeId);
      if (res) {
        apiRef.current.updateRows([{ id: removeId, _action: 'delete' }]);
        enqueueSnackbar('삭제 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setRemoveId(null);
  };

  const downloadFile = (event, file) => {
    event.ignore = true;
    const link = document.createElement('a');
    link.href = file.fileUrl;
    link.download = true;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);
  };

  const apiRef = useGridApiRef();
  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
        disableExport: true,
      },
      {
        field: 'prjUuid',
        headerName: '프로젝트ID',
        hide: true,
        type: 'string',
        editable: false,
        disableExport: true,
      },
      {
        field: 'filePartnerUuid',
        headerName: '견적서회사ID',
        hide: true,
        type: 'string',
        editable: false,
        disableExport: true,
      },
      {
        field: 'filePartnerNm',
        headerName: '매출처명',
        minWidth: 300,
        flex: 1,
        type: 'string',
        align: 'left',
        headerAlign: 'left',
        editable: false,
      },
      {
        field: 'fileRegDt',
        headerName: '받을(수신)일자',
        minWidth: 200,
        flex: 1,
        type: 'string',
        align: 'left',
        headerAlign: 'left',
        editable: false,
      },
      {
        field: 'fileCrtDt',
        headerName: '파일등록일',
        minWidth: 200,
        flex: 1,
        type: 'string',
        align: 'left',
        headerAlign: 'left',
        editable: false,
      },
      {
        field: 'cstNm',
        headerName: '사업명',
        minWidth: 400,
        flex: 1,
        description: '',
        align: 'left',
        headerAlign: 'left',
        editable: false,
      },
      {
        field: 'fileNm',
        headerName: '파일명',
        minWidth: 600,
        flex: 1,
        type: 'string',
        editable: false,
        disableClickEventBubbling: true,
        renderCell: (params) => (
          <div>
            {params.row?.fileNm}
            {params.row?.fileUrl && (
              <IconButton
                color="primary"
                size="small"
                sx={{ mx: 2 }}
                onClick={(e) => downloadFile(e, params.row)}
              >
                <CloudDownloadIcon />
              </IconButton>
            )}
          </div>
        ),
      },
      {
        field: 'fileCrtNm',
        headerName: '파일등록자',
        minWidth: 200,
        flex: 1,
        type: 'string',
        align: 'left',
        headerAlign: 'left',
        editable: false,
      },

      {
        field: 'actions',
        type: 'actions',
        headerName: 'Actions',
        width: 100,
        cellClassName: 'actions',
        getActions: ({ id }) => {
          return [
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              onClick={handleDeleteClick(id)}
              color="inherit"
            />,
          ];
        },
      },
    ],
    [apiRef, handleDeleteClick],
  );

  return (
    <div>
      <SalesFileList
        apiRef={apiRef}
        columns={columns}
        files={files}
        error={error}
        loading={loading}
        columnVisibilityModel={{
          id: false,
          prjUuid: false,
		  filePartnerUuid: false,
		}}

      />
      <AskDialog
        visible={visible}
        title="매출발주서 삭제"
        description="선택한 매출발주서 파일을 삭제하시겠습니까?"
        confirmText="삭제"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </div>
  );
};

export default SalesFileListContainer;
